import { Backpack, Flame, Heart, Map, Star, TerminalSquare } from "lucide-react";
import type { ProgressState } from "../types";

type HeaderProps = {
  progress: ProgressState;
  active: "map" | "coding" | "backpack";
  onMap: () => void;
  onCoding: () => void;
  onBackpack: () => void;
};

export function Header({ progress, active, onMap, onCoding, onBackpack }: HeaderProps) {
  return (
    <header className="game-header">
      <button className="brand" type="button" onClick={onMap} aria-label="回到知识地图">
        <span className="brand-orbit" aria-hidden="true">🪐</span>
        <span>AI 星球大冒险</span>
      </button>
      <nav className="main-nav" aria-label="主导航">
        <button className={active === "map" ? "active" : ""} type="button" onClick={onMap}>
          <Map aria-hidden="true" /> <span>知识地图</span>
        </button>
        <button className={active === "coding" ? "active" : ""} type="button" onClick={onCoding}>
          <TerminalSquare aria-hidden="true" /> <span>手写工坊</span>
        </button>
        <button className={active === "backpack" ? "active" : ""} type="button" onClick={onBackpack}>
          <Backpack aria-hidden="true" /> <span>我的背包</span>
        </button>
      </nav>
      <div className="hud" aria-label="学习状态">
        <span title="爱心"><Heart aria-hidden="true" /> {progress.hearts}</span>
        <span title="星星币"><Star aria-hidden="true" /> {progress.stars}</span>
        <span title="连续学习"><Flame aria-hidden="true" /> {progress.streak}天</span>
      </div>
    </header>
  );
}
